import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfessionalHomeComponent } from './professional-home/professional-home.component';
import { ProfessionalContributionsParentComponent } from './contributions-parent/contributions-parent.component';
import { ContributionManagementComponent } from './contribution-management/contribution-management.component';
import { ProfessionalBioComponent } from './professional-bio/professional-bio.component';
import { ProfessionalStatusComponent } from './professional-status/professional-status.component';
import { ProfessionalLinksComponent } from './professional-links/professional-links.component';
import { ProfessionalSpecialismsComponent } from './specialisms/professional-specialisms.component';
import { ProfessionalCulturesComponent } from './cultures/professional-cultures.component';

const routes: Routes = [
  {
    path: '',
    component: ProfessionalHomeComponent,
    children: [
      { path: '', redirectTo: 'bio', pathMatch: 'full' },
      {
        path: 'bio',
        component: ProfessionalBioComponent,
        data: { label: 'Biography', translationKey: 'navigation.bio', labelSource: null },
      },
      {
        path: 'status',
        component: ProfessionalStatusComponent,
        data: { label: 'Status', translationKey: 'navigation.status', labelSource: null },
      },
      {
        path: 'specialisms',
        component: ProfessionalSpecialismsComponent,
        data: { label: 'Specialisms', translationKey: 'navigation.specialisms', labelSource: null },
      },
      {
        path: 'cultures',
        component: ProfessionalCulturesComponent,
        data: { label: 'Cultures', translationKey: 'common.cultures', labelSource: null },
      },
      {
        path: 'contributions',
        data: { label: 'Contributions', translationKey: 'content.contributions', labelSource: null},
        children: [
          {
            path: '',
            component: ProfessionalContributionsParentComponent,
          },
          {
            path: ':id',
            data: { label: 'Contribution', translationKey: 'content.contribution', labelSource: 'titleService'},
            component: ContributionManagementComponent
          }
        ]
      },
      {
        path: 'links',
        component: ProfessionalLinksComponent,
        data: { label: 'Professional Links', translationKey: 'content_management.links', labelSource: null },
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProfessionalRoutingModule { }
